import { isAxiosError, type AxiosInstance } from 'axios'
import type { Usuario } from './usuario';
import z from 'zod';
import { TipoUsuario } from './tipo-usuario';
import { SchemaUsuario } from './schema-usuario';

type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>

const searchRequestSchema = z.object({
    id: z.optional(z.uuidv7()),
    id_in: z.optional(z.array(z.uuidv7())),
    nome: z.optional(z.string()),
    login: z.optional(z.string()),
    tipo: z.optional(z.enum(TipoUsuario)),
    tipo_in: z.optional(z.array(z.enum(TipoUsuario))),
    offset: z.number().default(0).optional(),
    limit: z.optional(z.number())
})
type SearchRequest = z.infer<typeof searchRequestSchema>


export class UsuarioRepository {
    constructor(
        private api: AxiosInstance
    ) { }

    async getById(id: string): Promise<Omit<Usuario, 'senha'>> {
        try {
            const { data } = await this.api.get<Omit<Usuario, 'senha'>>(`/usuarios/${id}`)
            console.log(data)
            return SchemaUsuario.parse(data)
        } catch (error) {
            let message = 'Não foi possível encontrar o usuário'
            if (isAxiosError(error)) {
                message = error.response?.data?.error || 'Não foi possível encontrar o usuário'
            }
            if (error instanceof Error) {
                message = error.message
            }
            throw new Error(message)
        }
    }
    async search(query?: SearchRequest): Promise<Omit<Usuario, 'senha'>[]> {
        try {
            let params = {}
            if (query) {
                params = searchRequestSchema.parse(query)
            }

            const { data } = await this.api.get<Omit<Usuario, 'senha'>[]>(`/usuarios`, {
                params
            })

            console.log({ data })

            return z.array(SchemaUsuario).parse(data)
        } catch (error) {
            let message = 'Não foi possível encontrar o usuário'
            if (isAxiosError(error)) {
                message = error.response?.data?.error || 'Não foi possível encontrar o usuário'
            }
            if (error instanceof Error) {
                message = error.message
            }
            throw new Error(message)
        }
    }
    async save(record: Optional<Usuario, 'id' | 'created_at' | 'updated_at'>): Promise<Omit<Usuario, 'senha'>> {
        try {


            const { data } = await this.api.post<Omit<Usuario, 'senha'>>(`/usuarios`, record)

            return SchemaUsuario.parse(data)
        } catch (error) {
            let message = 'Não foi possível salvar o usuário'
            if (isAxiosError(error)) {
                message = error.response?.data?.error || 'Não foi possível salvar o usuário'
            }
            if (error instanceof Error) {
                message = error.message
            }
            throw new Error(message)
        }
    }
    async remove(ids: string[]): Promise<void> {
        try {

            await this.api.delete<Omit<Usuario, 'senha'>>(`/usuarios`, {
                data: {
                    ids
                }
            })

        } catch (error) {
            let message = 'Não foi possível remover o(s) usuário(s)'
            if (isAxiosError(error)) {
                message = error.response?.data?.error || 'Não foi possível remover o(s) usuário(s)'
            }
            if (error instanceof Error) {
                message = error.message
            }
            throw new Error(message)
        }
    }
    async count(query?: SearchRequest): Promise<number> {
        try {
            let params = {}
            if (query) {
                params = searchRequestSchema.parse(query)
            }

            const { data } = await this.api.get<{ total: number }>(`/usuarios/count`, {
                params
            })

            return data.total
        } catch (error) {
            let message = 'Não foi possível encontrar o usuário'
            if (isAxiosError(error)) {
                message = error.response?.data?.error || 'Não foi possível encontrar o usuário'
            }
            if (error instanceof Error) {
                message = error.message
            }
            throw new Error(message)
        }
    }
}